import React from 'react'
import backgroundImage from "../assets/background/backgroundprivacy.jpg"

const TermsConditionsPage = () => {
    return (
        <section id="privacypolicy " className="w-full overflow-hidden relative">

            <div className='h-full w-full absolute top-0 bottom-0 opacity-10'>
                <img src={backgroundImage} className='w-full h-full object-cover' alt='Background' />
            </div>


            <div className="container mx-auto my-10 px-4 relative z-10">
                <div className="">
                    <h2 className="text-2xl lg:text-3xl font-extrabold text-center">
                        Terms & Conditions
                    </h2>
                    <div className="px-10 p-0.5 max-w-[100px] rounded-full bg-blue-800 mt-2 mb-12 mx-auto"></div>
                </div>

                <div className='content max-w-5xl mx-auto'>
                    {/* <h2 className='text-xl font-bold mb-1'>
                Privacy Policy for Harmony Infra Solutions Private Limited
            </h2> */}

                    <h2 className='text-lg font-bold mt-6 mb-1'>
                        Effective Date: July 15, 2025
                    </h2>
                    <h2 className='text-lg font-bold mb-6'>
                        Last Updated: July 15, 2025
                    </h2>


                    <p className='mb-3'>
                        Welcome to https://www.houseseekers.in (the &quot;Website&quot;), owned and operated by House Seekers, a real
                        estate consultancy company headquartered in Thane, Maharashtra, India. Please read these Terms &amp;
                        Conditions (&quot;Terms&quot;) carefully before using this Website.
                    </p>
                    <br />
                    <p>
                        By accessing or using this Website, you acknowledge that you have read, understood, and agree to be
                        bound by these Terms and all applicable laws and regulations. If you do not agree with these Terms,
                        please do not use this Website.
                    </p>


                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        1. About House Seekers
                    </h2>
                    <p>
                        Founded in 2016, House Seekers is a leading technology-enabled real estate consulting company. We
                        provide personalized property consultation services across residential and commercial segments and are
                        known for our partnerships with top developers including Lodha, Piramal Realty, Birla Estates, Oberoi,
                        Rustomjee, Runwal, Prestige, and others.
                    </p>

                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        The Website serves as a platform to:
                    </h2>

                    <ul className='list-disc pl-5'>
                        <li>
                            Showcase our brand and expertise
                        </li>
                        <li>
                            Share company insights and partnerships
                        </li>
                        <li>
                            Provide career opportunities for job seekers
                        </li>
                    </ul>


                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        2. Use of the Website
                    </h2>
                    <p>
                        You may use the Website only for lawful purposes and in accordance with these Terms. You agree not to:
                    </p>
                    <ul className='list-disc pl-5'>
                        <li>
                            Use the Website in any way that violates applicable laws or regulations
                        </li>
                        <li>
                            Use the Website for the purpose of exploiting, harming, or attempting to harm others
                        </li>
                        <li>
                            Upload or transmit viruses, malware, or any other harmful code
                        </li>
                        <li>
                            Attempt to gain unauthorized access to any part of the Website
                        </li>
                        <li>
                            Impersonate or misrepresent your affiliation with House Seekers
                        </li>
                        <li>
                            Reproduce, distribute, modify, or create derivative works from Website content without prior
                            written permission
                        </li>
                    </ul>



                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        3. Intellectual Property
                    </h2>
                    <p>
                        All content on this Website, including text, graphics, logos, images, and software, is the intellectual
                        property of House Seekers or its partners and is protected under applicable copyright, trademark, and
                        intellectual property laws.
                    </p>
                    <br />



                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        4. Disclaimer
                    </h2>
                    <p>
                        The content provided on this Website is for informational purposes only. House Seekers does not
                        guarantee the accuracy, completeness, or timeliness of any information on the Website.
                    </p>
                    <p>
                        We do not make any warranties, express or implied, about the Website’s operation or its content,
                        including but not limited to warranties of merchantability, fitness for a particular purpose, or non-
                        infringement.
                    </p>



                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        5. Limitation of Liability
                    </h2>
                    <p>
                        To the fullest extent permitted by law, House Seekers shall not be liable for any indirect, incidental,
                        special, consequential, or punitive damages, or any loss of profits or revenues, arising from your use or
                        inability to use this Website.
                    </p>




                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        6. Third-Party Links
                    </h2>
                    <p>
                        The Website may contain links to third-party websites for your convenience. We do not endorse or
                        assume responsibility for the content or privacy practices of any third-party websites. Use of third-party
                        websites is subject to their own terms and policies.
                    </p>




                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        7. Careers and Job Applications
                    </h2>
                    <p>
                        Users may submit resumes and personal details for job opportunities listed on the Website. Such data will
                        be used solely for recruitment purposes. Submission of your resume does not guarantee job placement or
                        interview. House Seekers reserves the right to retain and review job applications as necessary.
                    </p>


                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        8. Privacy
                    </h2>
                    <p>
                        Use of the Website is also governed by our Privacy Policy, which outlines how your personal data is
                        collected, stored, and processed. By using this Website, you consent to the terms outlined in our Privacy
                        Policy.
                    </p>



                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        9. Indemnification
                    </h2>
                    <p>
                        You agree to indemnify, defend, and hold harmless House Seekers, its directors, employees, agents, and
                        affiliates, from any claims, liabilities, damages, losses, or expenses (including legal fees) arising out of
                        your use of the Website or your violation of these Terms.
                    </p>


                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        10. Governing Law and Jurisdiction
                    </h2>
                    <p>
                        These Terms shall be governed by and construed in accordance with the laws of India. Any disputes
                        arising out of or relating to these Terms or your use of the Website shall be subject to the exclusive
                        jurisdiction of the courts in Thane, Maharashtra.
                    </p>


                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        11. Dispute Resolution
                    </h2>
                    <p>
                        In the event of a dispute, the parties agree to attempt to resolve the issue amicably through informal
                        negotiations. If unresolved, the matter shall be referred to arbitration in accordance with the Arbitration
                        and Conciliation Act, 1996.
                    </p>

                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        12. Amendments
                    </h2>
                    <p>
                        House Seekers reserves the right to modify or update these Terms at any time without prior notice.
                        Changes will be posted on this page with the updated effective date. Your continued use of the Website
                        constitutes acceptance of the revised Terms.
                    </p>




                    <h2 className='text-lg font-bold mt-3 mb-1'>
                        13. Contact Us
                    </h2>
                    <p>
                        If you have any questions or concerns regarding these Terms, please contact us at: <span className='font-medium'>7718064506</span>
                    </p>



                    <h2 className='text-lg font-bold mt-6'>
                        House Seekers
                    </h2>
                    <p>
                        Thane, Maharashtra, India
                    </p>
                    <p>
                        Email: mukesh@houseseekers.in
                    </p>
                    <p>
                        Phone: 7718064506
                    </p>

                </div>

            </div>
        </section>
    )
}

export default TermsConditionsPage